import request from './request'

/** 获取银行列表 */
export function getBankList(): Promise<string[]> {
	return request.get('/api/common/getBankList').then((data) => data.list)
}

/** 请求验证-开通虚拟账户 */
export function openAccount(data: any) {
	return request({
		method: 'POST',
		url: '/api/business_join/openAccount',
		data,
		reportError: (res) => res.code !== 2001,
	})
}

/** 请求验证-绑定银行卡 */
export function bindBank(data: any) {
	return request.post('/api/business_join/bindBank', data)
}

/** 查询打款状态 */
export function bindBankQuery() {
	return request.get('/api/business_join/bindBankQuery')
}

/** 绑定银行卡-验证确认 */
export function bindBankVerify(data: any) {
	return request({
		method: 'POST',
		url: '/api/business_join/bindBankVerify',
		data,
		reportError: false,
	})
}

/** 验证结果查询 */
export function bindVerifyQuery(seqId: string) {
	return request({
		method: 'GET',
		url: '/api/business_join/bindVerifyQuery',
		params: { tb_bind_verify_seqid: seqId },
		reportError: false,
	})
}

/** 查询财务信息 */
export function queryFinanceInfo() {
	return request
		.get('/api/business_join/queryFinanceInfo')
		.then((data) => data.bus_info)
}

/** 保存财务信息 */
export function saveFinanceInfo(data: any) {
	return request.post('/api/business_join/saveFinanceInfo', data)
}

/** 查询联系人手机列表 */
export function getBindMobiles() {
	return request.get('/api/business_join/queryBindMobiles')
}

/** 银行卡识别接口 */
export function queryBankCardInfo(img_url: string) {
	return request.get(`/api/ocr/bankCard?img_url=${img_url}`)
}
